import { render, staticRenderFns } from "./RegisterBarnAltModal.vue?vue&type=template&id=4dc96814&scoped=true&"
import script from "./RegisterBarnAltModal.vue?vue&type=script&lang=js&"
export * from "./RegisterBarnAltModal.vue?vue&type=script&lang=js&"
import style0 from "./RegisterBarnAltModal.vue?vue&type=style&index=0&id=4dc96814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc96814",
  null
  
)

export default component.exports